<script lang="ts">
    import { onDestroy, onMount } from 'svelte';
    import { sendLoginEvent } from '$lib/services/gtm/methods';

    import { sendLoginStats } from '@api/user/stats';
    import { globalStore } from '@components/stores';
    import { Dialog, dialogStore } from '@components/ui/dialog';
    import LL from '@i18n/i18n-svelte';
    import { EventType, PaymentSource } from '@shared/types';
    import { Button, ButtonTypes } from '@uikit/button';
    import { Font, FontTypes } from '@uikit/font';

    import s from './vpn-detected.module.css';

    async function onClick() {
        dialogStore.showBuyMembership({ source: PaymentSource.VpnDetected });
    }

    onMount(() => {
        sendLoginEvent({ event: EventType.VpnDetectedShow });
        sendLoginStats(EventType.VpnDetectedShow, $globalStore.isDesktopSite);
    });

    onDestroy(() => {
        sendLoginEvent({ event: EventType.VpnDetectedClose });
        sendLoginStats(EventType.VpnDetectedClose, $globalStore.isDesktopSite);
    });
</script>

<Dialog>
    <Font tagName={FontTypes.TagName.h2} type={FontTypes.Type.h3} isBold className={s.title}>
        {$LL.dialogs.vpnDetected.title()}
    </Font>
    <Font tagName={FontTypes.TagName.p} type={FontTypes.Type.body} className={s.text}>
        {$LL.dialogs.vpnDetected.text()}
    </Font>

    <div class={s.buttons}>
        <Button
                classes={s.button}
                color={ButtonTypes.Color.Secondary}
                on:click={() => dialogStore.closeDialog()}
                attrs={{ 'data-testid': 'close' }}
        >
            {$LL.dialogs.vpnDetected.close()}
        </Button>
        <Button
                classes={s.button}
                color={ButtonTypes.Color.Brand}
                on:click={onClick}
                attrs={{ 'data-testid': 'getMemberShip' }}
        >
            {$LL.dialogs.vpnDetected.getMemberShip()}
        </Button>
    </div>
</Dialog>
